import { render, staticRenderFns } from "./ladder-blend-coupon-tab.vue?vue&type=template&id=fecc70d8&scoped=true&lang=pug&"
import script from "./ladder-blend-coupon-tab.vue?vue&type=script&lang=js&"
export * from "./ladder-blend-coupon-tab.vue?vue&type=script&lang=js&"
import style0 from "./ladder-blend-coupon-tab.vue?vue&type=style&index=0&id=fecc70d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecc70d8",
  null
  
)

export default component.exports